import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Collapsible } from "@similarweb/ui-components";

export const StyledSettingsSection = styled.div<{ isCollapsed: boolean }>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    margin-top: 38px;
    cursor: pointer;
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
`;

export const StyledCollapsible = styled(Collapsible)<{ isActive: boolean }>`
    overflow: ${({ isActive }) => (isActive ? "unset !important" : "hidden")};
`;
